<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    :formInputs="formInputs"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from '../../../components/crud/CrudBase';
import { yesNoRepresentation } from '@/helpers/transformers';

export default {
  name: 'cobranca-cliente',
  components: { CrudBase },
  data() {
    return {
      url: '/admin/condicoes/cobranca-cliente',
      columns: [
        { label: 'ID', field: 'id', sortable: false },
        {
          label: 'Cobrança',
          field: 'cobranca',
          sortable: false,
          representedAs: (row) =>
            row?.cobranca
              ? `${row.cobranca_id} - ${row.cobranca.descricao}`
              : row.cobranca_id,
        },
        {
          label: 'Cliente',
          field: 'cliente',
          sortable: false,
          representedAs: (row) =>
            row?.cliente
              ? `${row.cliente_id} - ${row.cliente.razaosocial}`
              : row.cliente_id,
        },
        {
          label: 'Ativo',
          field: 'ativo',
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: {
          type: 'string',
          ui: {
            label: 'Identificador',
            columns: 4,
            widget: 'AutoIdWidget',
            widgetConfig: { campo1Key: 'cobranca_id', campo2Key: 'cliente_id' },
          },
          rules: { required: { value: true, errMsg: 'Preencha o Identificador.' } },
        },
        cobranca_id: {
          type: 'number',
          ui: {
            label: 'Cobrança',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/cobrancas',
              idField: 'id',
              labelField: 'descricao',
              preload: true,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        cliente_id: {
          type: 'number',
          ui: {
            label: 'Cliente',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/clientes',
              idField: 'id',
              labelField: 'razSoc',
              labelFields: ['razSoc', 'fant'],
              preload: false,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        ativo: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Ativo',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessob2b: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível B2B?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessocallcenter: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível Call?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessofv: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível FV?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        ordem: {
          type: 'number',
          default: 1,
          ui: { label: 'Ordem', columns: 4 },
        },
      },
    };
  },
};
</script>
